export default __webpack_public_path__ + "static/media/customer-service.fa64c493.svg";